import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-stories-dialog',
  templateUrl: './stories-dialog.component.html',
  styleUrls: ['./stories-dialog.component.css']
})
export class StoriesDialogComponent implements OnInit {

  storiesList:any =[];

  constructor(public dialog: MatDialog, public dialogRef: MatDialogRef<StoriesDialogComponent>,@Inject(MAT_DIALOG_DATA ) public data: any) { }

  ngOnInit(): void {
    this.storiesList = this.data;
    console.log(this.data);
  }

  close() {
    this.dialogRef.close(true);
  }

}
